import { Dropzone } from './Dropzone';
import { MediaType } from '../types';
import getAcceptedFileTypes from '../utils';

export interface UploadDropzoneProps {
  onUpload: (files: FileList) => void;
  acceptedFileTypes?: MediaType[];
}

export const UploadDropzone = ({ onUpload, acceptedFileTypes = [] }: UploadDropzoneProps) => {
  return (
    <Dropzone onUpload={onUpload} acceptedFileTypes={acceptedFileTypes}>
      <div className="upload-dropzone-content">
        <p><b>Start adding your files</b></p>
        <div>Drop files here or&nbsp;
          <label className="btn btn-small btn-link" aria-label="Upload new assets">
            upload from computer
            <input
              type="file"
              multiple
              accept={acceptedFileTypes.map(type => getAcceptedFileTypes(type)).join(',')}
              onChange={(e) => e.target.files && onUpload(e.target.files)}
              style={{ display: 'none' }}
              aria-label="Select files to upload"
            />
          </label>
        </div>
      </div>
    </Dropzone>
  );
};
